<div class="card-container">
  <div class="unlock">
    <h6 class="card-title" [innerHTML]="title"></h6>
  </div>
  <!--border -->
  <div class="star-img">
    <img src="../../../assets/images/thumb_up.svg" alt="">
  </div>
  <div class="mark-lucky">
    <p>{{description}}</p>
  </div>
  <div class="choose-btn">
    <button (click)="goToSyndicates()">{{yesButton}}</button>
  </div>
  <div class="decline_btn">
    <span class="no_button" (click)="closePopup()">{{noButton}}</span>
  </div>
</div>